import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { orderRemiderService, OrderReminderApiParameterData } from "@TKCCP/Services/OrderReminderService";
import { CustomApiHandlerDiscreteParameter } from "@TKCCP/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface OrderReminderParameter {
    CustomerId: string;
    EmailReminderforOrders: boolean;
    onSuccess?: () => void;
}
type HandlerType = CustomApiHandlerDiscreteParameter<OrderReminderParameter, OrderReminderApiParameterData, {}>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        CustomerId: props.parameter.CustomerId,
        EmailReminderforOrders: props.parameter.EmailReminderforOrders,
    };
};
export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await orderRemiderService(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};
export const DispatchBeginLoadOrderReminder: HandlerType = props => {
    props.dispatch({
        type: "Data/AttributeValues/CompleteLoadmailReminderforOrders",
        result: props.apiParameter.EmailReminderforOrders,
    });
};

export const chain = [PopulateApiParameter, SendDataToApi, DispatchBeginLoadOrderReminder, ExecuteOnSuccessCallback];

const OrderRemainderData = createHandlerChainRunner(chain, "OrderRemainderData");
export default OrderRemainderData;
